import React from 'react';
import RatingAnswerSurveyTracking from './branch/RatingAnswerSurveyTracking';
import RatingAnswerSurvey from './branch/RatingAnswerSurvey';
import RatingAnswerSurvey_0201 from './branch/RatingAnswerSurvey_0201';
import RatingAnswerSurveyTracking_0202 from './branch/RatingAnswerSurveyTracking_0202';
import RatingAnswerSurvey_0202 from './branch/RatingAnswerSurvey_0202';
import RatingAnswerSurvey_0301 from './branch/RatingAnswerSurvey_0301';
import RatingAnswerSurveyTracking_0201 from './branch/RatingAnswerSurveyTracking_0201';
import RatingAnswerSurveyTracking_0301 from './branch/RatingAnswerSurveyTracking_0301';
import {
  initEditorValuesBranch,
  initTrackingValuesBranch,
  initViewValuesBranch
} from './branch/initBranchValues';

export const initViewValues = {
  currentIndex: 0,
  starIndex: 2,
  bg: { background: 'color' },
  bgImage: {
    background: ['https://image.inappmessage.com/sample/undefined.png'],
    logo: ['https://image.inappmessage.com/sample/rating_answer_survey_01.png'],
    ...initViewValuesBranch?.bgImage
  },
  bgColor: {
    close: ['#ffffff'],
    background: ['#ffffff'],
    ...initViewValuesBranch?.bgColor
  },
  radius: { background: 20, button: 8, ...initViewValuesBranch?.radius },
  deeplink: { ...initViewValuesBranch?.deeplink },

  text: {
    title: ['메트릭 사용 경험에 대한\n평점을 남겨주세요!'],
    sub_title: [
      '고객님들의 남겨주시는 소중한 의견을 통해\n더 나은 서비스를 제공할 수 있도록\n개선하도록 하겠습니다.'
    ],
    ...initViewValuesBranch?.text
  },
  fontSize: { title: 1.25, sub_title: 0.75, ...initViewValuesBranch?.fontSize },
  fontWeight: {
    title: 700,
    sub_title: 400,
    ...initViewValuesBranch?.fontWeight
  },
  color: {
    title: '#000000',
    sub_title: '#828282',
    ...initViewValuesBranch?.color
  },
  fontFamily: {
    title: 'Montserrat',
    sub_title: 'Montserrat',
    ...initViewValuesBranch?.fontFamily
  },
  textAlign: {
    title: 'center',
    sub_title: 'center',
    ...initViewValuesBranch?.textAlign
  },

  btnText: { button: ['다음으로'], ...initViewValuesBranch?.btnText },
  btnFontSize: {
    selected_button: 0.875,
    button: 0.875,
    ...initViewValuesBranch?.btnFontSize
  },
  btnFontWeight: {
    selected_button: 600,
    button: 600,
    ...initViewValuesBranch?.btnFontWeight
  },
  btnColor: {
    selected_button: '#000000',
    button: '#ffffff',
    selected_option_button: '#4778FF',
    option_button: '#4F4F4F',
    ...initViewValuesBranch?.btnColor
  },
  btnBgColorR: {
    selected_button: 255,
    button: 152,
    ...initViewValuesBranch?.btnBgColorR
  },
  btnBgColorG: {
    selected_button: 255,
    button: 152,
    ...initViewValuesBranch?.btnBgColorG
  },
  btnBgColorB: {
    selected_button: 255,
    button: 152,
    ...initViewValuesBranch?.btnBgColorB
  },
  btnBgColorA: {
    selected_button: 1,
    button: 1,
    ...initViewValuesBranch?.btnBgColorA
  },
  btnFontFamily: {
    selected_button: 'Montserrat',
    button: 'Montserrat',
    ...initViewValuesBranch?.btnFontFamily
  }
};

export const initTrackingValues = {
  tracking: {
    close: ['close button 1'],
    button: ['submit button 1'],
    ...initTrackingValuesBranch?.tracking
  },
  logCustom: { ...initTrackingValuesBranch?.logCustom }
};

export const init_editor_values_rating_answer_survey = {
  branch: [1, 2, 1],
  contents: {
    bgImageType: ['logo', 'background'],
    bgColorType: ['close', 'background'],
    bg: ['background'],
    bgRadius: ['background'],
    bgRadiusMax: [150],
    bgImage: ['logo'],
    bgColor: ['close', 'back'],

    textType: ['title', 'sub_title'],
    text: ['title', 'sub_title'],
    fontSize: ['title', 'sub_title'],
    fontWeight: ['title', 'sub_title'],
    color: ['title', 'sub_title'],
    fontFamily: ['title', 'sub_title'],
    textAlign: ['title', 'sub_title']
  },
  buttons: {
    branchType: true,
    btnType: [
      'selected_option_button',
      'option_button',
      'selected_button',
      'button'
    ],
    btnText: [undefined, undefined, undefined, 'button'],
    btnFontSize: [undefined, undefined, 'selected_button', 'button'],
    btnFontWeight: [undefined, undefined, 'selected_button', 'button'],
    btnColor: [
      'selected_option_button',
      'option_button',
      'selected_button',
      'button'
    ],
    btnBgColor: [undefined, undefined, 'selected_button', 'button'],
    btnFontFamily: [undefined, undefined, 'selected_button', 'button'],
    radius: [undefined, undefined, undefined, 'button'],
    radiusMax: [undefined, undefined, undefined, 30]
  },
  trackings: {
    trackingType: ['close', 'button'],
    logCustomType: []
  },
  ...initEditorValuesBranch
};

export const ViewTemplates = {
  '': <RatingAnswerSurvey />,
  '0201': <RatingAnswerSurvey_0201 />,
  '0202': <RatingAnswerSurvey_0202 />,
  '0301': <RatingAnswerSurvey_0301 />
};

export const TrackingTemplates = {
  '': <RatingAnswerSurveyTracking />,
  '0201': <RatingAnswerSurveyTracking_0201 />,
  '0202': <RatingAnswerSurveyTracking_0202 />,
  '0301': <RatingAnswerSurveyTracking_0301 />
};
